(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["promo-item-count"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
  const promoBanner = document.querySelector('.promotional-wrapper');
  if (!promoBanner) return;

  const updateBannerState = () => {
    promoBanner.classList.toggle('promotional-active', window.scrollY > 0);
  };

  // Run immediately on DOM ready
  requestAnimationFrame(updateBannerState);

  // Recheck after browser restores scroll position
  window.addEventListener('scroll', updateBannerState, { passive: true });
  window.addEventListener('load', () => {
    // Browsers restore scroll position after load
    setTimeout(updateBannerState, 50); // small delay for scroll restoration
  });

  // Also handle pages where scroll restoration happens via history API
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      setTimeout(updateBannerState, 50);
    }
  });
});
  } catch(e) { console.error(e); }
})();

})();
